import { useUserOrganization } from '../../organization'
import { useUmbrella } from '../umbrellaContext'
import { useUserUmbrellas } from '../userUmbrellasContext'

interface UmbrellaStatus {
  hasUmbrellas: boolean
  isOrganizationMode: boolean
  isLoading: boolean
}

export const useUmbrellaStatus = (): UmbrellaStatus => {
  const { umbrella, isLoading: isUmbrellaLoading } = useUmbrella()
  const { userUmbrellas } = useUserUmbrellas()
  const { isLoading: isOrgLoading } = useUserOrganization()

  return {
    hasUmbrellas: userUmbrellas.length > 0,
    isOrganizationMode: !umbrella,
    isLoading: isOrgLoading && isUmbrellaLoading,
  }
}
